// Import 3rd-party dependencies
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

// Import project-specific dependencies
import { FEEDBACK_COMPONENT_CONSTS } from '@app/config/constants';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.css']
})
export class FeedbackComponent {
  consts = FEEDBACK_COMPONENT_CONSTS;
  num: number = this.consts.QUALTRICS.INT;

  constructor(public dialog: MatDialog) {
    // Remove Qualtrics Feedback function from DXC Hub & My Hub - Story: https://dev.azure.com/DXCIT/DXC%20IT%20Backlog/_workitems/edit/114800
    // this.callQualtricsSurvey();
  }

  // Remove Qualtrics Feedback function from DXC Hub & My Hub - Story: https://dev.azure.com/DXCIT/DXC%20IT%20Backlog/_workitems/edit/114800
  // callQualtricsSurvey(): void {
  //   this.startSession();
  // }

    //TH-1833 Application (retro) unit testing (Feedback), after debugging code, comment out the code that doesn't run

    // const element = this.startSession();
    // this.consts.COMPLETE !== document.readyState
    //   ? window.addEventListener
    //     ? window.addEventListener(
    //         'load',
    //         function () {
    //           element;
    //         },
    //         false
    //       )
    //     : window.addEventListener &&
    //       window.addEventListener('onload', function () {
    //         element;
    //       })
    //   : this.startSession();
  

  // setExpiryDate(id: string, arr: string): void {
  //   const date = new Date();
  //   date.setTime(date.getTime() + this.consts.WEEK_IN_SECONDS);
  //   const expiry = `${this.consts.EXPIRY_STRING}${date.toUTCString()}`;
  //   document.cookie = `${id}-${arr}${expiry}${this.consts.PATH_STRING}`;
  // }

  // START - Remove Qualtrics Feedback function from DXC Hub & My Hub - Story: https://dev.azure.com/DXCIT/DXC%20IT%20Backlog/_workitems/edit/114800
  // getSession(input: string): string {
  //   for (let a = `${input}=`, c = document.cookie.split(';'), b = 0, thing = c.length; b < thing; b++) {
  //     for (let d = c[b]; ' ' === d.charAt(0); ) {
  //       d = d.substring(1, d.length);
  //       if (d.indexOf(a) === 0) {
  //         return d.substring(a.length, d.length);
  //       }
  //     }
  //   }
  //   return null;
  // }

  // startSession(): HTMLElement {
  //   if (this.noExistingSession()) {
  //     const element = document.createElement('script');
  //     element.type = this.consts.TYPE;
  //     element.src = this.consts.QUALTRICS.LINK;
  //     document.body && document.body.appendChild(element);

  //     return element;
  //   } else {
  //     return null;
  //   }
  // }

  // noExistingSession(): boolean {
  //   const session: string = this.getSession(this.consts.QUALTRICS.ID);
  //   let arr: unknown[];

  //   if (session) {
  //     arr = session.split(':');
  //   } else {
  //     return true;
  //   }
  // }
  // END- Remove Qualtrics Feedback function from DXC Hub & My Hub - Story: https://dev.azure.com/DXCIT/DXC%20IT%20Backlog/_workitems/edit/114800

    //TH-1833 Application (retro) unit testing (Feedback), after debugging code, comment out the code that doesn't run

    // if (this.consts.CODE !== this.num) {
    //   this.consts.V_CHAR === this.consts.QUALTRICS.CODE &&
    //     (this.num =
    //       Math.random() >= this.consts.QUALTRICS.INT / this.consts.CODE ? this.consts.ZERO : this.consts.CODE),
    //     (arr = [this.consts.QUALTRICS.CODE, this.num, this.consts.ZERO]),
    //     this.setExpiryDate(this.consts.QUALTRICS.ID, arr.join(':'));
    // }

    // let num: number = session[1] as unknown as number;
    // if (num === this.consts[100]) {
    //   return true;
    // }
    // switch (session[0]) {
    //   case this.consts.V_CHAR:
    //     return false;
    //   case this.consts.R_CHAR:
    //     return (
    //       (num =
    //         ((session[2] as unknown as number) % Math.floor(this.consts[100] / num),
    //         (session[2] as unknown as number)++,
    //         this.setExpiryDate(this.consts.QUALTRICS.ID, arr.join(':')) as unknown as number)),
    //       !num
    //     );
    // }
    // return true;
}
